import { useEffect, useState } from 'react'
import { ListFilterDrawer } from '@/components/ui/ListFilterDrawer'
import { formatDateForAPI } from '@/features/invitee/utils/inviteeFormatters'
import type { ApiLogsFilterState } from '../types/filters'
import { ReportDateRangePicker } from './ReportDateRangePicker'
import type { ApiLogsFiltersProps } from '../types/components'
import { LABEL_CLASS } from '../constants/configuredReportStyles'

export type { ApiLogsFilterState } from '../types/filters'

export function ApiLogsFilters({
  filters,
  isOpen,
  onClose,
  onApply,
  onReset,
}: ApiLogsFiltersProps) {
  const [draft, setDraft] = useState<ApiLogsFilterState>(filters)

  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect -- intentional: re-sync the filter draft to applied filters each time the drawer opens
    if (isOpen) setDraft(filters)
  }, [isOpen, filters])

  return (
    <ListFilterDrawer
      isOpen={isOpen}
      onClose={onClose}
      onReset={onReset}
      onDone={() => {
        onApply(draft)
        onClose()
      }}
      testIdPrefix="api-logs"
    >
      <div className="space-y-2">
        <label className={LABEL_CLASS}>Date Range</label>
        <ReportDateRangePicker
          startDate={draft.fromDt}
          endDate={draft.toDt}
          onChange={(start, end) =>
            setDraft({
              fromDt: start ? formatDateForAPI(start) : '',
              toDt: end ? formatDateForAPI(end) : '',
            })
          }
          placeholder="Select Date Range"
        />
      </div>
    </ListFilterDrawer>
  )
}
